export default __webpack_public_path__ + "static/media/gp-cometa.42981413.svg";